/**
 * Fontes que o lojista pode escolher. Lista curada: todas existem no Google Fonts
 * (menos Arial, que é do aparelho) e têm os pesos 400 a 700 que a vitrine usa.
 */
export const THEME_FONTS = [
    'Arial',
    'Inter',
    'Roboto',
    'Open Sans',
    'Lato',
    'Poppins',
    'Montserrat',
    'Nunito',
    'Raleway',
    'DM Sans',
    'Work Sans',
    'Oswald',
    'Playfair Display',
    'Lora',
    'Merriweather',
    'Cormorant Garamond',
];
/** Fontes que já existem no aparelho; as demais vêm do Google Fonts. */
export const THEME_SYSTEM_FONTS = ['Arial'];
//# sourceMappingURL=fonts.js.map